module.exports = {
      id: "wi-fi-no-usage",
      viewBox: "0 0 36 36",
      url: __webpack_public_path__ + "assets/img/sprite-598bc0.svg#wi-fi-no-usage",
      toString: function () {
        return this.url;
      }
    }